import en_us from './en-us.js';

const i18n = en_us;

export default i18n;